/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMLoginLessBeginPayload } from '@/data/types/GTM';

export const getGTMLoginLessBeginEventData = (payload: GTMLoginLessBeginPayload) => ({
	login_step: payload.login_step,
	login_origin: payload.login_origin,
});
